<template>
  <div>
    <h1>Averages</h1>
    <p v-if="!averages">This could take some time to load</p>
    <v-progress-circular indeterminate color="info" v-if="!averages" />
    <table border="1" v-if="averages">
      <tr>
        <th />
        <th
          colspan="2"
          v-for="(averagesQuoteType, aqtindex) in averages.averagesReferrers[0].averagesQuoteTypes"
          :key="`aqt${aqtindex}`"
        >{{averagesQuoteType.quoteType.name}}</th>
      </tr>
      <tr>
        <th />
        <template
          v-for="(averagesQuoteType, aqtindex) in averages.averagesReferrers[0].averagesQuoteTypes"
        >
          <template
            v-for="(averagesQuestionTypeOption, aqtoindex) in averagesQuoteType.averagesQuestionTypeOptions"
          >
            <th
              :key="`aqt${aqtindex}aqto${aqtoindex}`"
            >{{averagesQuestionTypeOption.questionTypeOption.value}}</th>
          </template>
        </template>
      </tr>
      <tr v-for="(averagesReferrer, arindex) in averages.averagesReferrers" :key="`ar${arindex}`">
        <th>{{averagesReferrer.referrer.name}}</th>
        <template v-for="(averagesQuoteType, aqtindex) in averagesReferrer.averagesQuoteTypes">
          <template
            v-for="(averagesQuestionTypeOption, aqtoindex) in averagesQuoteType.averagesQuestionTypeOptions"
          >
            <td
              style="text-align: right;"
              :title="averagesQuestionTypeOption.count"
              :key="`ar${arindex}aqt${aqtindex}aqto${aqtoindex}`"
            >{{averagesQuestionTypeOption.average | toCurrency}}</td>
          </template>
        </template>
      </tr>
    </table>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Averages",
  metaInfo() {
    return {
      title: "Averages",
      titleTemplate: "%s - Sales - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  data() {
    return {
      averages: null
    };
  },
  methods: {
    fetchAverages() {
      return nbmlaw.get(`/cors/admin/sales/averages`).then(response => {
        // console.log(response);
        this.averages = response.data;
      });
    }
  },
  created() {
    this.fetchAverages();
  }
};
</script>